require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-linked-lists-in-objective-c-theres-a-protocol-for-that.json") })
        }
      }, "path---blog-linked-lists-in-objective-c-theres-a-protocol-for-that");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-linked-lists-in-objective-c-theres-a-protocol-for-that!./.cache/json/blog-linked-lists-in-objective-c-theres-a-protocol-for-that.json
// module id = 911
// module chunks = 231608221292675